export const highlightStyles = { backgroundColor: "#FFD300" };
